<template>
    <section>

        <page-header>
            <slot slot="title">{{ $t('header.menu.customer_list') }}</slot>
            <slot slot="description">
                <p>Intro klantenlijst - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.</p>
            </slot>
            <slot slot="action">
                <div class="u-pos-relative c-customer-search">
                    <h5 class="u-text-uppercase">{{ $t('customer_list.find_customer') }}</h5>
                    <v-input v-model="CustomerListOptions.searchTerm"
                             :horizontal="true"
                             :fluid="true"
                             :name="`${_uid}-customer-search`"
                             :placeholder="$t('customer_list.enter_term')"
                             custom-class="c-customer-search__input"
                             autocomplete="off"
                             type="search"
                             @input="customerSearch">
                    </v-input>
                    <div v-if="isSalesman" class="c-customer-list__button" style="padding-left: 165px; padding-top: 5px;">
                        <v-switch v-model="CustomerListOptions.myCustomersOnly"
                                  name="my-customers-only"
                                  @input="customerSearch">
                            <slot slot="label">{{ $t('customer_list.my_customers') }}</slot>
                        </v-switch>
                    </div>
                </div>
            </slot>
        </page-header>

        <div class="u-pos-relative">
            <v-loading :data="loaded" class="loading-position"></v-loading>

            <div class="o-wrapper o-wrapper--center u-padding-bottom">
                <table-component class="o-page-row u-table-scroll"
                                 filter-no-results=""
                                 table-class="c-table c-table--small"
                                 :data="Customers"
                                 :show-caption="false"
                                 :show-filter="false">

                    <table-column show="AltKey" key="AltKey" :label="$t('customer_list.columns.customer_number')" :sortable="false"></table-column>
                    <table-column show="Name" key="Name" :label="$t('customer_list.columns.name')" :sortable="false"></table-column>
                    <table-column show="Zipcode" key="Zipcode" :label="$t('customer_list.columns.zipcode')" :sortable="false"></table-column>
                    <table-column show="City" key="City" :label="$t('customer_list.columns.city')" :sortable="false"></table-column>
                    <table-column show="Email" key="Email" :label="$t('customer_list.columns.email')" :sortable="false"></table-column>

                    <!-- DETAILS -->
                    <table-column cell-class="u-text-nowrap" :label="$t('customer_list.columns.details')" :sortable="false" :filterable="false">
                        <template slot-scope="row">
                            <div class="o-spacing-tiny">
                                <router-link class="c-button c-button--alpha c-button--tiny c-button--neutral" :to="{ name: 'CustomerListView', params: { id: row.Key }}">
                                    {{ $t('global.details') }}
                                </router-link>
                            </div>
                        </template>
                    </table-column>

                    <!-- USERS -->
                    <table-column cell-class="u-text-nowrap" :label="$t('customer_list.columns.users')" :sortable="false" :filterable="false">
                            <template slot-scope="row">
                                <div class="o-spacing-tiny">
                                    <router-link class="c-button c-button--alpha c-button--tiny c-button--neutral" :to="{ name: 'CustomerUsers', query: { customerKey: row.Key }}">
                                        {{ $t('customer_list.columns.users') }}
                                    </router-link>
                                </div>
                            </template>
                        </table-column>

                    <!-- IMPERSONATE -->
                    <table-column cell-class="u-text-nowrap" :label="$t('customer_list.columns.impersonate')" :sortable="false" :filterable="false">
                        <template slot-scope="row">
                            <div class="o-spacing-tiny">
                                <button @click.prevent="impersonateUser(row.Key)"
                                        :title="row.Name"
                                        type="button"
                                        class="c-button c-button--alpha c-button--icon c-button--tiny">
                                    <svgicon name="user" width="1em" height="1em"></svgicon>
                                    <span>Inloggen als klant</span>
                                </button>
                            </div>
                        </template>
                    </table-column>

                </table-component>

                <div v-if="!Customers.length" class="u-font-large u-text-align-center u-padding">
                    {{ $t('customer_list_overview.no_customers_added') }}<br>
                    <span class="u-font-default">{{ $t('customer_list_overview.use_search') }}</span>
                </div>

                <v-pagination v-if="CustomersPagination"
                              class="c-pager o-page-row"
                              :config="PaginationConfig"
                              :pagination="CustomersPagination"
                              @paginated="setSearchTerm">
                </v-pagination>
            </div>

        </div>
    </section>
</template>

<script>
    // general
    import Vue from 'vue'
    import VLoading from '@/components/Loading'
    import VPagination from '@/components/Pagination'
    import debounce from 'lodash/debounce'
    import PageHeader from '@/components/common/PageHeader'
    import VInput from '@/components/form/Input'
    import VSwitch from '@/components/form/Switch'

    // store
    import {mapGetters} from 'vuex'

    export default {
        props: {},
        components: {
            PageHeader,
            VLoading,
            VPagination,
            VInput,
            VSwitch
        },
        data() {
            return {
                loaded: { isLoaded: true },
                PaginationConfig: { Page: 1 }
            }
        },
        computed: {
            ...mapGetters({
                Customers: 'Customers',
                CustomersFilters: 'CustomersFilters',
                CustomersPagination: 'CustomersPagination',
                CustomerListOptions: 'CustomerListOptions'
            }),
            isSalesman() {
                return this.$store.getters.isSalesman;
            },
        },
        methods: {
            customerSearch() {
                this.setSearchTerm();
                this.PaginationConfig.Page = 1;
            },
            setSearchTerm: debounce(function() {
                if (this.CustomerListOptions.searchTerm.length > 2) {
                    this.loaded = {};
                    this.$store.dispatch('getCustomers', {
                        params: {
                            searchTerm: this.CustomerListOptions.searchTerm,
                            MyCustomersOnly: this.isSalesman ? this.CustomerListOptions.myCustomersOnly : false,
                            Page: this.PaginationConfig.Page
                        }
                    }).then(() => {
                        this.loaded = { isLoaded: true };
                    }).catch(() => {
                        this.loaded = { isLoaded: true };
                    });
                }
            }, 500),
            impersonateUser(user) {
                this.$store.dispatch('impersonateUser', user).then(() => {
                    this.$store.dispatch('checkAuth');
                    this.$router.push("/customer")
                }).catch((e) => {
                    this.$notify({
                        group: 'global',
                        title: e.Message,
                        type: 'error',
                        duration: 4000
                    });
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .loading-position {
        position: absolute;
        width: 100%;
        top: 36px;
    }

    .c-customer-list__button {
        @include down($desktop) {
            position: absolute;
            right: 25px;
            bottom: 85px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/salesman/customerList/CustomerListOverview.vue